import React from 'react';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';

function Login() {
    // const [logindata, setLogindata] = useState({});

    const [value, setvalue] = useState({
        email: '',
        password: '',
    });

    const handlechange = (e) => {
        const { name, value } = e.target;
        setvalue((prevstate) => ({ ...prevstate, [name]: value }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const { email, password } = value;
        const response = await fetch('https://generativebackend.onrender.com/api/login', {
            // http://localhost:4000/api/login
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify({
                email,
                password,
            }),
        });
        setvalue({
            email: '',
            password: '',
        });

        const data = await response.json();
        console.log(data);
        // setLogindata(data);
        // console.log(data);

        if (data.user) {
            localStorage.setItem('token', data.user);
            localStorage.setItem('detail', data.userData.name);
            toast.success('Login Sucessfully', {
                duration: '3000',
            });
            window.location.href = '/dashboard';
        } else {
            toast.error("This didn't work.");
        }
    };

    // useEffect(() => {
    //     handleSubmit()
    // }, [])
    return (
        <>
            <h1 style={{ textAlign: 'center' }}>Login </h1>
            <div className="container" style={{ textAlign: 'center' }}>
                <div className="card">
                    <form onSubmit={handleSubmit}>
                        <input type="email" name="email" id="email" placeholder="email" value={value.email} onChange={handlechange} />
                        <br />
                        <input
                            type="password"
                            name="password"
                            id="password"
                            placeholder="password"
                            value={value.password}
                            onChange={handlechange}
                        />{' '}
                        <br />
                        <input type="submit" name="" id="" />
                    </form>
                </div>
                <p>
                    If You dont Create any account Please <Link to="/register">Register</Link>!
                </p>
            </div>
        </>
    );
}

export default Login;
